export default "* Hvilke farver kender I fra naturen?\n* Hvad betyder ordet nuance?\n* Hvilken farve tror I bliver lettest og sværest at finde?\n";